import apiHandler from "./apiHandler";



const apiFeed = {
  post: {
    create: (post, airline) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .post(`/feed/post`, {
            airline,
            content: post.content,
            images: post.images,
            tags: post.tags,
            publish: post.publish,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addImage: (post, image) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .post(`/feed/post/${post._id}/image`, {
            image: image,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteImage: (post, filename) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/feed/post/${post._id}/image/${filename}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    update: (post) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .patch(`/feed/post/${post._id}`, {
            content: post.content,
            tags: post.tags,
            publish: post.publish,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (post) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/feed/post/${post._id}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  feed: (airlines, pilots, tags, beforeDate, beforeId, limit, showFuture) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/feed`, {
          airlines,
          pilots,
          tags,
          beforeDate,
          beforeId,
          limit,
          showFuture,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiFeed;
